// i18n
import translations from './i18n.json';
import { translateInComponent } from 'infras/i18n';

import styled from '@emotion/styled';
import ServicePageTemplate from 'presentations/views/components/templates/ServicePageTemplate';
import ServiceFeatureListItem from 'presentations/views/components/molecules/FeatureListItem';
import SectionTitle from 'presentations/views/components/molecules/ServiceSectionTitle';
import {
  background,
  black,
  gray03,
  gray04,
  whiteFix,
} from 'presentations/views/styles/color';
import Header from 'presentations/views/components/organisms/Header';
import Headline from 'presentations/views/components/atoms/Headline';
import Icon from 'presentations/views/components/atoms/Icon';
import FeatureMainVisual from 'presentations/views/components/organisms/service/FeatureMainVisual';
import { ViewerItem } from 'presentations/api/schema/user';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { FeatureListItem } from 'presentations/api/schema/contents';
import BackgroundContainer from 'presentations/views/components/organisms/service/BackgroundContainer';

interface Props {
  viewer: ViewerItem | null;
  features: FeatureListItem[];
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const categories = [
    'core',
    'customization',
    // 'business',
    // 'team',
    'integration',
    'admin',
  ];
  return (
    <ServicePageTemplate
      isVisibleSupport={true}
      header={<Header viewer={props.viewer} />}
      breadcrumbs={[]}
    >
      <Page>
        <MainVisualContainer>
          <MainVisual>
            <FeatureMainVisual />
          </MainVisual>
        </MainVisualContainer>
        <AnchorNavigationContainer>
          <AnchorNavigationTitle variant="h3">
            {t('features')}
          </AnchorNavigationTitle>
          <AnchorNavigation>
            {categories.map((c) => (
              <AnchorButton href={`#${c}`}>
                {t(c)}
                <AnchorButtonIcon name="expand_more" />
              </AnchorButton>
            ))}
          </AnchorNavigation>
        </AnchorNavigationContainer>

        {categories.map((c) => (
          <SectionContainer id={c}>
            <SectionTitle title={t(c)} />
            <List>
              {props.features
                .filter((f) => f.category === c)
                .map((feature) => (
                  <ListItem>
                    <ServiceFeatureListItem feature={feature} />
                  </ListItem>
                ))}
            </List>
          </SectionContainer>
        ))}
      </Page>
    </ServicePageTemplate>
  );
}

const List = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: ${spacing(24)};
  grid-row-gap: ${spacing(40)};
  ${mediaMax.tablet} {
    grid-template-columns: 1fr;
  }
`;
const ListItem = styled.div``;

const Page = styled.div``;
const MainVisualContainer = styled(BackgroundContainer)`
  display: flex;
  justify-content: center;
`;
const SectionContainer = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: ${spacing(128)} ${spacing(16)} ${spacing(96)};
  ${mediaMax.tablet} {
    padding: ${spacing(48)} ${spacing(16)};
  }
  border-bottom: 1px solid ${gray03};
`;
const MainVisual = styled.div`
  padding: ${spacing(56)} ${spacing(24)};
  display: flex;
  justify-content: center;
  max-width: 960px;
  ${mediaMax.tablet} {
    padding: ${spacing(16)} ${spacing(12)};
  }
`;
const AnchorNavigationContainer = styled.div`
  /* border-top: 1px solid ${gray03}; */
  border-bottom: 1px solid ${gray03};
  padding: ${spacing(24)} ${spacing(16)} ${spacing(24)};
`;
const AnchorNavigation = styled.div`
  margin-top: ${spacing(20)};
  display: flex;
  justify-content: center;
  ${mediaMax.tablet} {
    flex-wrap: wrap;
  }
`;
const AnchorButton = styled.a`
  display: inline-flex;
  padding: ${spacing(8)} 0;
  margin-right: ${spacing(16)};
  width: 146px;
  text-align: center;
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(16)};
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${black};
  border-radius: ${borderRadius(6)};
  background-color: ${background};
  color: ${black};
  :hover {
    background-color: ${gray04};
    color: ${whiteFix};
  }
  :last-of-type {
    margin-right: 0;
  }
  ${mediaMax.tablet} {
    width: 108px;
    font-size: ${fontSize(12)};
    padding: ${spacing(4)} 0;
    margin-right: ${spacing(8)};
    margin-bottom: ${spacing(12)};
    white-space: nowrap;
  }
`;
const AnchorButtonIcon = styled(Icon)`
  margin: 0 auto;
  ${mediaMax.tablet} {
    width: 16px !important;
    height: 16px !important;
  }
`;

const AnchorNavigationTitle = styled(Headline)`
  text-align: center;
  /* margin-top: ${spacing(20)}; */
`;
